import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { getXsrfToken } from '../../base/utils';
import { GET_PERSONALIZE_ANONYMOUS, GET_USER_MARKNAME, SET_PERSONALIZE_ANONYMOUS, } from './cgi-path';
import { IDocMetaDomainService, } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { networkRequest, } from '@tencent/ark-request';
import { isArray, } from '@tencent/ark-utils/lib/types';
var CollaborateRepository = /** @class */ (function () {
    function CollaborateRepository(docMetaDomain) {
        this.docMetaDomain = docMetaDomain;
    }
    /**
     * 获取用户昵称信息。
     * 只有透过以下两种方式之一后台接口才能解析到入参：
     * 1. 直接把参数写在 url 后面，GET or POST 皆可。（uids 过长时会出问题，不建议使用）
     * 2. 使用 POST 方式调用，并且将参数填写在表单里。（JSON 格式不行）
     * 优化建议：不要同时支持 string[] | string 两种类型，建议只支持 string[]。
     * @param uids
     * @param extra 其他不固定参数
     */
    CollaborateRepository.prototype.getUserMarkName = function (uids, extra) {
        return __awaiter(this, void 0, void 0, function () {
            var formattedUids, data, params;
            return __generator(this, function (_a) {
                formattedUids = this.getFormattedUidsString(uids);
                data = __assign(__assign({}, extra), { localPadId: this.docMetaDomain.docMetaEntity.padInfo.padId, domainId: this.docMetaDomain.docMetaEntity.padInfo.domainId, 
                    // uid 这里必须用字符串，整形会有精度丢失的问题
                    uids: formattedUids });
                params = {
                    xsrf: getXsrfToken(),
                };
                return [2 /*return*/, networkRequest.post(GET_USER_MARKNAME, data, { params: params })];
            });
        });
    };
    /**
     * 设置匿名
     * @param status 匿名状态 1: 开启 2: 关闭
     * @param file_id
     */
    CollaborateRepository.prototype.setPersonalizeAnonymous = function (status, file_id) {
        return __awaiter(this, void 0, void 0, function () {
            var data, params;
            return __generator(this, function (_a) {
                data = {
                    status: status,
                    file_id: file_id || this.docMetaDomain.docMetaEntity.padInfo.padId,
                };
                params = {
                    xsrf: getXsrfToken(),
                };
                return [2 /*return*/, networkRequest.post(SET_PERSONALIZE_ANONYMOUS, data, { params: params })];
            });
        });
    };
    /**
     * 查询匿名设置
     * @param file_id
     */
    CollaborateRepository.prototype.getPersonalizeAnonymous = function (file_id) {
        return __awaiter(this, void 0, void 0, function () {
            var data, params;
            return __generator(this, function (_a) {
                data = {
                    file_id: file_id || this.docMetaDomain.docMetaEntity.padInfo.padId,
                };
                params = {
                    xsrf: getXsrfToken(),
                };
                return [2 /*return*/, networkRequest.post(GET_PERSONALIZE_ANONYMOUS, data, { params: params })];
            });
        });
    };
    /**
     * 生成能被后台接口解析到的 uids 参数格式字符串。格式形如：[144115210349177900,38119995...]
     * @param uids
     */
    CollaborateRepository.prototype.getFormattedUidsString = function (uids) {
        return isArray(uids) ? "[".concat(uids.toString(), "]") : "[".concat(uids, "]");
    };
    CollaborateRepository = __decorate([
        __param(0, IDocMetaDomainService),
        __metadata("design:paramtypes", [Object])
    ], CollaborateRepository);
    return CollaborateRepository;
}());
export { CollaborateRepository };
